// extracted by mini-css-extract-plugin
module.exports = {"root":"LocationSummary_root__UHI4d","icon":"LocationSummary_icon__HicxM","reviews":"LocationSummary_reviews__0Xpyc"};